var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92857 1.92857L7.59995 6.21139L7.60184 6.21296C8.23157 6.67476 8.54663 6.9058 8.8917 6.99506C9.19671 7.07395 9.51733 7.07395 9.82234 6.99506C10.1677 6.90572 10.4837 6.67401 11.1145 6.21139C11.1145 6.21139 14.7522 3.4198 16.7857 1.92857M1 11.0288V3.97161C1 2.93151 1 2.41108 1.20242 2.01381C1.38047 1.66437 1.66437 1.38047 2.01381 1.20242C2.41108 1 2.93151 1 3.97161 1H14.743C15.7831 1 16.3025 1 16.6997 1.20242C17.0492 1.38047 17.334 1.66437 17.5121 2.01381C17.7143 2.41069 17.7143 2.93049 17.7143 3.96856V11.0319C17.7143 12.07 17.7143 12.589 17.5121 12.9859C17.334 13.3353 17.0492 13.6197 16.6997 13.7978C16.3028 14 15.7838 14 14.7457 14H3.96856C2.93049 14 2.41069 14 2.01381 13.7978C1.66437 13.6197 1.38047 13.3353 1.20242 12.9859C1 12.5886 1 12.0689 1 11.0288Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailResend);
export default __webpack_public_path__ + "static/media/mailResend.67190637e82b2857b227409a5db0d99a.svg";
export { ForwardRef as ReactComponent };